import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/store';

export const value = (state: RootState) => state.faqQuestions.value;
export const request = (state: RootState) => state.faqQuestions.request;

export const isLoaded = createSelector(value, (v) => v !== null);
export const isLoading = createSelector(request, (r) => r === 'loading');
export const isError = createSelector(request, (r) => r === 'error');
export const questions = createSelector(value, (v) => v ?? []);

// Only load when idle — stops retrying after a rejection ('error' state)
export const shouldLoad = createSelector(
  value,
  request,
  (v, r) => v === null && r === 'idle',
);
